(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanda-editorial"] && !Shopify.designMode) return;
  try {
    
(function() {
  var imgs = document.querySelectorAll(
    '.ve-panel__img-inner img, .ve-skin__img img'
  );
  if (!imgs.length) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var img = entry.target;
        setTimeout(function() {
          img.classList.add('ve-animate');
        }, 100);
      } else {
        entry.target.classList.remove('ve-animate');
      }
    });
  }, { threshold: 0.1 });
  imgs.forEach(function(img) {
    observer.observe(img);
  });
})();

function selectSize(el, sizesId, cartId) {
  var sizes = document.getElementById(sizesId).querySelectorAll('.ve-panel__size');
  sizes.forEach(function(s) { s.classList.remove('active'); });
  el.classList.add('active');
  var cartBtn = document.getElementById(cartId);
  if (cartBtn) { cartBtn.dataset.variant = el.dataset.variant; }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanda-product-bridge"]) return;
  try {
    
(() => {
  const initialize = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.vpb-product[data-vpb-lead]').forEach((product) => {
      const gallery = product.querySelector('media-gallery');
      if (!gallery || gallery.dataset.vpbMobileReady === 'true') return;
      const lead = product.dataset.vpbLead;
      const slide = lead && gallery.querySelector(`[data-media-id$="-${lead}"]`);
      const thumbnail = slide && gallery.querySelector(`[data-target="${slide.dataset.mediaId}"]`);
      if (!slide || !thumbnail || typeof gallery.setActiveMedia !== 'function') {
        gallery.dataset.vpbMobileReady = 'true';
        return;
      }
      const image = slide.querySelector('img');
      if (image) { image.loading = 'eager'; image.fetchPriority = 'high'; }
      try { gallery.setActiveMedia(slide.dataset.mediaId, true); }
      finally { gallery.dataset.vpbMobileReady = 'true'; }
    });
  };
  if (window.customElements) customElements.whenDefined('media-gallery').then(initialize);
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
